/**
 * AV API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AvBemerkungVersionId } from './avBemerkungVersionId';
import { HistInfo } from './histInfo';


export interface AvBemerkungVersionDetailEntry { 
    id: AvBemerkungVersionId;
    histInfo?: HistInfo;
    art?: AvBemerkungVersionDetailEntry.ArtEnum;
    andereArt?: string;
    bemerkung?: string;
    editActions?: Array<AvBemerkungVersionDetailEntry.EditActionsEnum>;
    modificationCounter: number;
}
export namespace AvBemerkungVersionDetailEntry {
    export type ArtEnum = 'NATURDENKMAL' | 'LAGEFIXPUNKT' | 'STREITIGE_GRENZE' | 'EINGEDOLTES_GEWAESSER' | 'ANDERE';
    export const ArtEnum = {
        NATURDENKMAL: 'NATURDENKMAL' as ArtEnum,
        LAGEFIXPUNKT: 'LAGEFIXPUNKT' as ArtEnum,
        STREITIGE_GRENZE: 'STREITIGE_GRENZE' as ArtEnum,
        EINGEDOLTES_GEWAESSER: 'EINGEDOLTES_GEWAESSER' as ArtEnum,
        ANDERE: 'ANDERE' as ArtEnum
    };
    export type EditActionsEnum = 'AENDERN' | 'KORRIGIEREN' | 'STREICHEN' | 'STORNIEREN';
    export const EditActionsEnum = {
        AENDERN: 'AENDERN' as EditActionsEnum,
        KORRIGIEREN: 'KORRIGIEREN' as EditActionsEnum,
        STREICHEN: 'STREICHEN' as EditActionsEnum,
        STORNIEREN: 'STORNIEREN' as EditActionsEnum
    };
}


